import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

import { formatCurrency } from '../../billing/timesheets/BillingTools';
import LineItem from './LineItem';

// const laaAssessmentMeetingCode = 'QUIQR';

// const adminCharge = {
//     "description": "Administration Charge",
//     "key": "ADMIN01",
//     "category": "services",
//     "quantity": 1,
//     "code": "adminCharge",
//     "measure": "hour",
//     "amount": 40,
//     "rate": 40,
//     "section": "assessment"
// };

const AssessmentServices = ({ tariff, quote, timesheet, onChange }) => {

    if (!quote && !timesheet) throw new Error("quote or timesheet is required");
    if (!tariff) throw new Error("tariff is required");

    const items = quote || timesheet;

    const [hideZeros, setHideZeros] = useState(timesheet && true);
    const [total, setTotal] = useState(items.netSectionTotal('assessment') + items.netSectionTotal('attendance'));

    const updateLineItem = (item) => {
        console.log('updateLineItem', item, tariff)
        items.apply(item);

        // if (item.key === laaAssessmentMeetingCode && tariff.code === 'defendant') {
        //     items.apply(adminCharge);
        // }

        setTotal(items.netSectionTotal('assessment') + items.netSectionTotal('attendance'));
        onChange();
    }

    const handleShowAll = () => {
        setHideZeros(!hideZeros);
    }

    return (
        <Paper style={{ padding: '0rem 1rem 1rem 1rem' }}>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <Typography variant="h6">Services</Typography>
                    {
                        timesheet &&
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={!hideZeros}
                                    onChange={handleShowAll}
                                    name="checkedB"
                                    color="primary"
                                />
                            }
                            label="Show All"
                        />
                    }
                </Grid>
                <Grid item xs={4} style={{ marginLeft: 'auto' }}>
                    {
                        quote && <Typography variant="h6" color="textSecondary">Net Total {formatCurrency(total)}</Typography>
                    }
                </Grid>
            </Grid>

            <Grid container style={{ marginTop: '1rem' }}>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='assessment' code='preparation' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='assessment' code='evaluation' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='assessment' code='report' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='attendance' code='fullday' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='attendance' code='halfday' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='attendance' code='conference' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                <Grid container>
                    <LineItem tariff={tariff} category='services' subsection='assessment' code='traveltime' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                </Grid>
                {
                    timesheet &&
                    <Grid container>
                        <LineItem tariff={tariff} category='services' subsection='attendance' code='cancellation' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                    </Grid>
                }
                {
                    timesheet &&
                    <Grid container>
                        <LineItem tariff={tariff} category='services' subsection='attendance' code='curtailment' quote={quote} timesheet={timesheet} dates={true} hideZeros={hideZeros} onChange={updateLineItem} />
                    </Grid>
                }
            </Grid>
        </Paper>
    );
}

export default AssessmentServices;